// @flow

import type {Effect} from '../../types'

import {
  take,
  put,
} from 'redux-saga/effects'
import {
  actions as routerActions,
} from 'redux-router5'

import {mapActions} from '../actions'

export function* searchByLocationEffect(): Effect {
  while (true) {
    const {payload: {city, district}} = yield take(mapActions.searchByLocation.id)
    yield put(routerActions.navigateTo('place-list', {city: city, district: district, page: 1}))
  }
}
